export default __webpack_public_path__ + "static/media/timer_background_m1.a4bf94e2.jpg";